(function () {
  var rootSelector = ".wd-product-social-proof";

  var closeModal = function (modal) {
    if (!modal) {
      return;
    }

    modal.classList.remove("is-active");
    modal.setAttribute("hidden", "hidden");
    document.body.classList.remove("scroll-padding-0");
    document.body.style.overflow = "";

    var video = modal.querySelector("video");

    if (video) {
      video.pause();
      video.removeAttribute("src");
      video.load();
    }

    var iframe = modal.querySelector("iframe");

    if (iframe) {
      iframe.removeAttribute("src");
    }

    document.querySelectorAll(rootSelector + " .wd-product-social-proof__preview-video").forEach(function (previewVideo) {
      previewVideo.play().catch(function () {});
    });
  };

  var openModal = function (modal, trigger) {
    if (!modal || !trigger) {
      return;
    }

    var card = trigger.closest(".wd-product-social-proof__card");
    var previewVideo = card && card.querySelector(".wd-product-social-proof__preview-video");

    if (previewVideo) {
      previewVideo.pause();
    }

    var videoType = trigger.getAttribute("data-video-type");
    var videoSrc = trigger.getAttribute("data-video-src");
    var videoId = trigger.getAttribute("data-video-id");
    var video = modal.querySelector("video");
    var iframe = modal.querySelector("iframe");

    if (videoType === "mp4" && video && videoSrc) {
      video.src = videoSrc;
      video.hidden = false;

      if (iframe) {
        iframe.hidden = true;
        iframe.removeAttribute("src");
      }

      modal.classList.add("is-active");
      modal.removeAttribute("hidden");
      document.body.classList.add("scroll-padding-0");
      document.body.style.overflow = "hidden";
      video.play().catch(function () {});
      return;
    }

    if ((videoType === "youtube" || videoType === "vimeo") && iframe && videoId) {
      var iframeSrc =
        videoType === "youtube"
          ? "https://www.youtube.com/embed/" + videoId + "?autoplay=1"
          : "https://player.vimeo.com/video/" + videoId + "?autoplay=1";

      iframe.src = iframeSrc;
      iframe.hidden = false;

      if (video) {
        video.hidden = true;
        video.pause();
        video.removeAttribute("src");
      }

      modal.classList.add("is-active");
      modal.removeAttribute("hidden");
      document.body.classList.add("scroll-padding-0");
      document.body.style.overflow = "hidden";
    }
  };

  var init = function () {
    document.querySelectorAll(rootSelector).forEach(function (section) {
      var modal = section.querySelector(".wd-product-social-proof__modal");

      if (!modal || section.dataset.wdSocialProofBound === "true") {
        return;
      }

      section.dataset.wdSocialProofBound = "true";

      section.addEventListener("click", function (event) {
        var openButton = event.target.closest("[data-wd-social-proof-open]");

        if (openButton && section.contains(openButton)) {
          event.preventDefault();
          openModal(modal, openButton);
          return;
        }

        if (
          event.target.closest("[data-wd-social-proof-close]") ||
          event.target === modal.querySelector(".wd-product-social-proof__modal-backdrop")
        ) {
          event.preventDefault();
          closeModal(modal);
        }
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }

      document.querySelectorAll(rootSelector + " .wd-product-social-proof__modal.is-active").forEach(function (modal) {
        closeModal(modal);
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
